module.exports = __webpack_public_path__ + "static/media/background_image_2.8ccc53c7.jpg";